class Cargo{
    constructor(id, codigo, descripcion, codigo_nomenclador, cantidad_horas){
        this.id = id;
        this.codigo = codigo;
        this.descripcion = descripcion;
        this.codigo_nomenclador = codigo_nomenclador;
        this.cantidad_horas = cantidad_horas;
    }
}
export default Cargo;